import http from '@/utils/services/http'

export function cadastrarPericia (id, data) {
  if (typeof id !== 'undefined' && !!id) {
    return updatePericia(id, data)
  }
  return http.post(`/api/policiacivil/pericia`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
export function findPericia (id) {
  return http.get(`/api/policiacivil/pericia/${id}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}
export function updatePericia (id, data) {
  return http.patch(`/api/policiacivil/pericia/${id}`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function updatePlacaAlterada (id, data) {
  return http.patch(`/api/policiacivil/pericia/grv/${id}/atualizar-placa-alterada`, data)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function uploadArquivo (grvId, file) {
  return http.post(`/api/policiacivil/pericia/grv/${grvId}/upload-pdf`, file)
    .then(result => Promise.resolve(result))
    .catch(error => Promise.reject(error))
}



// WEBPACK FOOTER //
// ./src/domain/policia-civil/pericia/services/pericia.js